export const getReportConfigQueryKey = (
  scope: 'WEBSITE' | 'FIGMA_PROTOTYPE',
  workspaceId?: string,
  prototypeId?: string
) => ['report-config', scope, workspaceId, prototypeId] as const;
